// extracted by mini-css-extract-plugin
export default {"form":"Form_form__2oTtv","inputWrapper":"Form_inputWrapper__xk3aW","wrapperButton":"Form_wrapperButton__crXSI"};